import { createContext, useContext, useSyncExternalStore } from "react";
import type { useClerk as clerkHook, useUser as userHook } from "@clerk/react";

type AuthState = ReturnType<typeof userHook>;
type AuthContextValue = { user: AuthState; clerk: ReturnType<typeof clerkHook> };
export const ResolvedAuthContext = createContext<AuthContextValue | null>(null);
const anonymousSnapshot = { isSignedIn: false };
let publicState = anonymousSnapshot;
const listeners = new Set<() => void>();
export function updatePublicAuth(isSignedIn: boolean) {
  if (publicState.isSignedIn === isSignedIn) return;
  publicState = { isSignedIn };
  listeners.forEach((listener) => listener());
}
/** Marketing pages need only the nav's signed-in flag, not the Clerk SDK. */
export function usePublicUser() {
  const resolved = useContext(ResolvedAuthContext);
  const snapshot = useSyncExternalStore((listener) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  }, () => publicState, () => anonymousSnapshot);
  return resolved?.user ?? snapshot;
}
export function useUser() {
  const value = useContext(ResolvedAuthContext);
  if (!value) throw new Error("Authenticated route requires AuthRuntime");
  return value.user;
}
export function useClerk() {
  const value = useContext(ResolvedAuthContext);
  if (!value) throw new Error("Authenticated route requires AuthRuntime");
  return value.clerk;
}
